import {
  AudienceOptionItem,
  AudienceOptions,
} from "../../types/audience-compare";

/**
 * Searches `options` to find the first item with a matching `value`.
 */
export const findAudienceOption = (
  val: string,
  options: AudienceOptions,
): AudienceOptionItem | null => {
  const [item, ...items] = options;
  if (!item) {
    return null;
  }

  if ("value" in item) {
    return item.value === val ? item : findAudienceOption(val, items);
  }

  // search through children options
  const child = findAudienceOption(val, item.items);

  // if it is NOT in the children continue searching siblings
  return child ? child : findAudienceOption(val, items);
};

const findFirstAudienceOptions = (
  options: AudienceOptions,
): AudienceOptionItem => {
  const first = options[0];
  return "value" in first ? first : first.items[0];
};

/**
 * Convenience wrapper over `findAudienceOption` which:
 *
 * 1. First attempts to find an item matching `val`
 * 2. Falls back to finding an item matching `fallbackVal`
 * 3. If neither can be found, returns the first `AudienceOptionItem` in `options`.
 */
export const findAudienceOptionOrFirstEntry = (
  val: string,
  fallbackVal: string,
  options: AudienceOptions,
): AudienceOptionItem => {
  return (
    findAudienceOption(val, options) ??
    findAudienceOption(fallbackVal, options) ??
    findFirstAudienceOptions(options)
  );
};
